<template>
  <div class="studio-page--widget">
    <div class="container text-center">
      <div class="row" v-if="isLoading">
        <div class="col-12 mt-3">
          <HMSpinner />
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-12 position-static">
          <FullEventsCalendar
            :calendarEvents="studioEvents"
            :hasMoreEvents="studioEventsHasMore"
            :isLoadingMore="studioEventsLoading"
            :openInNewWindow="true"
            template="widget"
            @loadMore="loadMoreEvents"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  name: 'widget-full-calendar',

  isStudio: true,
  hideTopBar: true,
  hideInstagramSlider: true,
  hideStudioContactInformation: true,
  hideCookieConsent: true,
  hideStudioAdminFooter: true,
  preventRefreshModal: true,
  preventScroll: true,
  hideMobileNav: true,
});
</script>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useStudioStore } from '@/stores/studio';
import FullEventsCalendar from '@/components/events/FullEventsCalendar.vue';
import { errorToMessage } from '@/utils/errors.js';
import HMSpinner from '@/components/common/HMSpinner.vue';

export default defineComponent({
  name: 'WidgetFullCalendar',
  components: {
    FullEventsCalendar,
    HMSpinner,
  },
  computed: {
    ...mapState(useStudioStore, {
      studio: state => state.currentStudio,
      studioEvents: state => state.studioEvents,
      studioEventsHasMore: state => state.studioEventsHasMore,
      studioEventsLoading: state => state.studioEventsLoading,
    }),
    studioURL() {
      return this.$studioURL;
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        await useStudioStore().getStudioEvents(this.studioURL);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load studio events',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isLoading = false;
      }
    },
    async loadMoreEvents() {
      await useStudioStore().loadMoreStudioEvents(this.studioURL);
    },
  },
  async mounted() {
    await this.loadData();
  },
});
</script>

<style scoped></style>
